import React from "react";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { ShowAt, HideAt } from "react-with-breakpoints";

export default function Posventa() {
  /* const handleShowDecription = ()=>{

    }
    style={{  visibility : description}} */

  const screenSize = {
    MOBILE: {
      titleMarginTop: "0",
      position: "relative",
      titleFontSize: "28px",
      titleAlignment: "text-left",
    },
    DESKTOP: {
      titleMarginTop: "130px",
      descriptionMarginTop: "20px",
      position: "absolute",
      bottom: 0,
      titleFontSize: "3.5rem",
      titleAlignment: "text-center",
    },
  };

  const cardData = [
    {
      title: "Turnos online",
      description: `Solicitá tu turno al taller de la forma más rápida.`,
      action: "Comprar",
      url: "https://store.autoprana.com.ar/#/servicios",
    },
    {
      title: "Accesorios",
      description: `Encontrá todos los accesorios para tu Toyota.`,
      action: "Comprar",
      url: "https://store.autoprana.com.ar/#/accesorios",
    },
    {
      title: "Repuestos",
      description: `Encontrá todos los accesorios para tu Toyota.`,
      action: "Comprar",
      url: "https://store.autoprana.com.ar/#/repuestos",
    },
    {
      title: "Contactanos",
      description: `Hace click para enviarnos un whatsapp o comunicate al 4505-8632.`,
      action: "Contactar",
      url: "https://wa.me/5491145058700?text=Hola,%20me%20estoy%20comunicando%20desde%20la%20web%20seccion%20posventa.%20Mi%20consulta%20es:%20",
    },
  ];

  const goToUrl = (url) => (window.location = url);

  const renderCards = (style) => (
    <Row
      className="m-0 p-4 cubeContainer"
      style={{
        backgroundImage: "url(images/homeNews/wallPosventa.jpg)",
      }}
    >
      <Col
        className={`${style.titleAlignment} mt-1`}
        xs={12}
        style={{ marginBottom: "30%", color: "white" }}
      >
        <span style={{ fontSize: style.titleFontSize, whiteSpace: "pre-line" }}>
          <b>
            Conocé los Servicios y Accesorios para tu {"\n"} Toyota en Prana
          </b>
        </span>
      </Col>

      {cardData.map(({ title, description, action, url }) => (
        <Col
          xs={12}
          lg={3}
          style={{ cursor: "pointer" }}
          className="m-0 p-0"
          onClick={() => goToUrl(url)}
        >
          <div className="grow" style={style}>
            <h2
              className="text-white text-left pl-4"
              style={{ marginTop: style.titleMarginTop }}
            >
              {title}
            </h2>
            <p
              className="text-white text-left px-4 pb-4"
              style={{ marginTop: style.descriptionMarginTop }}
            >
              {description}
              <span className="card-link-action" style={{ display: "block" }}>
                {action}
              </span>
            </p>
          </div>
        </Col>
      ))}
    </Row>
  );

  return (
    <>
      <ShowAt breakpoint="largeAndAbove">
        {renderCards(screenSize.DESKTOP)}
      </ShowAt>
      <HideAt breakpoint="largeAndAbove">
        {renderCards(screenSize.MOBILE)}
      </HideAt>
    </>
  );
}
